import type { TransferBoardOrder } from "./transfersWorkbenchTypes";

export function laneKeyForTransferOrder(order: Pick<TransferBoardOrder, "origin_location_id" | "destination_location_id">): string {
  return `${String(order.origin_location_id)}->${String(order.destination_location_id)}`;
}

export function listPendingTransferMoveTargets(
  orders: readonly TransferBoardOrder[],
  sourceOrderId: number,
  originLocationId: number,
  destinationLocationId: number,
): TransferBoardOrder[] {
  const laneKey = laneKeyForTransferOrder({ origin_location_id: originLocationId, destination_location_id: destinationLocationId });
  return orders.filter(
    (entry) =>
      entry.status === "pending"
      && entry.id !== sourceOrderId
      && laneKeyForTransferOrder(entry) === laneKey,
  );
}
